import clsx from "clsx";

import classes from "./styles.module.scss";

import type { ReactNode } from "react";

interface IProps {
  children: ReactNode;
  className?: string;
}

export function Container({ children, className }: IProps) {
  return <div className={clsx(classes.container, className)}>{children}</div>;
}
